<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <div class="right-search">
            <el-input
              class="search-input"
              placeholder="请输入证书编号或客户名称"
              v-model="search_name"
              :header-cell-style="getRowClass"
              prefix-icon="el-icon-search" @keyup.enter.native="searchCert">
            </el-input>
          </div>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="device_name"
            label="仪器名称">
          </el-table-column>
          <el-table-column
            prop="lab_order_id"
            width="70"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="company_name"
            label="客户名称">
          </el-table-column>
          <el-table-column
            prop="create_date"
            width="90"
            label="订单日期">
          </el-table-column>
<!--          <el-table-column
            prop="price"
            width="100"
            label="价格">
          </el-table-column>
          <el-table-column
            prop="cnas"
            width="100"
            label="CNAS">
            <template slot-scope="scope">{{ scope.row.cnas | cnas_filter}}</template>
          </el-table-column>
          <el-table-column
            prop="measure"
            label="范围">
          </el-table-column>
          <el-table-column
            prop="grade"
            label="等级">
          </el-table-column>
          <el-table-column
            prop="vendor"
            label="生产厂家">
          </el-table-column>        
-->
          <el-table-column
            prop="equip_code"
            width="100"
            label="器具编号">
          </el-table-column>
          <el-table-column
            prop="cert_code"
            label="证书编号">
          </el-table-column>
          <el-table-column
            prop="device_user"
            width="100"
            label="工程师">
          </el-table-column>
          <el-table-column
            prop="lab_name"
            label="委外实验室">
          </el-table-column>
          <el-table-column label="操作" v-if="user_type == 2">
            <template slot-scope="scope">
              <el-button
                class="delete-btn"
                @click="handleDelete(scope.row, scope.$index)"
                v-if="(scope.row.service_type == 0 ||  scope.row.service_type == 1) && (scope.row.status == 5 || scope.row.status  == 8) && scope.row.result == 0"
                >
                撤回证书
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="查看证书">
            <template slot-scope="scope">
              <el-button
                class="edit-btn"
                 @click="goSend(scope.row)"
                 v-if="(scope.row.service_type == 0 ||  scope.row.service_type == 1) && (scope.row.status == 5 || scope.row.status  == 8) && (user_type == 2)"
                >
                查看证书
              </el-button>
              <el-button
                class="edit-btn"
                 @click="download(scope.row)"
                 v-if="(scope.row.service_type == 0 ||  scope.row.service_type == 1) && (scope.row.status == 5 || scope.row.status  == 8) && (user_type == 1 || user_type == 5)"
                >
                查看证书
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 撤回的弹窗框 start -->
    <div  class="delete-container" v-if="deleteShow">
      <div class="delete-content">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
        <p class="delete-txt">确认要撤回该证书吗?</p>
        <div class="btn-container">
          <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
          <el-button class="btn-list sure-btn" @click="sureDelete">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 撤回的弹出框 end -->
  </div>
</template>

<script type='text/ecmascript-6'>
import base from 'common/js/base.js'
import { getStore } from 'common/js/mUtils'
export default {
  data () {
    return {
      search_name: '',
      empty: '请搜索需要撤回的证书。',
      tableData: [],
      device: {},
      deviceRule: {
      },
      deleteShow: false,
      deleteRow: {},
      deleteIndex: 0,
      options: [],
      type: '',
      user_type: ''
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = false
  },
  created () {
    this.user_type = getStore('user_type')
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    handleDelete (row, index) { // 点击撤回证书
      let that = this
      that.deleteIndex = index
      that.deleteRow = row
      that.deleteShow = true
    },
    cancleDelete () { // 取消
      this.$message({
        type: 'info',
        message: '取消撤回操作！',
        customClass: 'msg-position',
        showClose: true
      })
      this.deleteShow = false
    },
    sureDelete () { // 确认
      let that = this
      this.handleRevert(this.deleteIndex, this.deleteRow.detail_id, this.deleteRow.type)
      that.deleteShow = false
    },
    handleRevert(index, detail_id, type) {
      let that = this
      that.loading = true
      this.$api.engineerHandleRevert({
        detail_id: detail_id,
        type: type
      }).then(res => {
        that.loading = false
        if (res.data.msg === true) {
          that.$message({
            type: 'success',
            message: '证书撤回成功！！',
            customClass: 'msg-position',
            showClose: true
          })
          that.tableData[index].result = '7'
        } else {
          that.$message({
            type: 'error',
            message: res.data.error,
            customClass: 'msg-position',
            showClose: true
          })
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
      that.loading = false
    },
    searchCert () { // 初始化页面 发送 订单ID 获取订单详情
      let that = this
      if (that.search_name == '') {
        that.$message({
          type: 'error',
          message: '搜索条件不能为空。',
          customClass: 'msg-position',
          showClose: true
        }) 
        return
      }
      that.loading = true
      this.$api.engineerSearchCert({
        cert_code: that.search_name
      }).then(res => {
        that.loading = false
        if (res.data.length > 0) {
          that.tableData = res.data
        } else {
          that.tableData = []
          that.$message({
            type: 'error',
            message: '没有找到该证书编号的仪器。',
            customClass: 'msg-position',
            showClose: true
          }) 
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    openHtml(URL) {
      let  temp_form = document.createElement("form");
      temp_form.action = URL;
      temp_form.target = "_blank";
      temp_form.method = "post";
      temp_form.style.display = "none";
      let opt = document.createElement("input");
      opt.name="access_token";
      opt.value="证书参数"
      temp_form.appendChild(opt);
      document.body.appendChild(temp_form);
      temp_form.submit();
    },
    download (row) {
      this.device = {...row}
      let that = this
      that.$api.download({
        type: that.device.type,
        detail_id: that.device.detail_id
      }).then(res => {
        let blob = new Blob([res.data], { type: 'application/pdf' })
        let objectUrl = URL.createObjectURL(blob)
        window.open(objectUrl)
      })
    },
    goSend(row) { // 查看证书
      this.device = {...row}
      let that = this
      var md5 = require('md5');
      let local_type = parseInt(that.device.type) + base.jl_online;
      let da = md5(`jl001${local_type}-${that.device.detail_id}`)
      let url = `${base.office}verify%2F${da}`;
      that.openHtml(url);
    }
  },
  filters: {
    // CNAS状态
    cnas_filter(state) {
      if (state == 0) {
        return '不带CNAS'
      }
      if (state == 1) {
        return '带CNAS'
      }
    }
  },
  components: {
  },
  watch: {
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
@import '~common/stylus/deletebox.styl'
</style>
